package com.fireavert.yardi.common_data.data_models.requests.client_requests

import com.fireavert.yardi.common_data.data_models.YardiResidentStatusEnum
import kotlinx.serialization.Serializable

@Serializable
data class YardiClientResidentByStatusRequest(
    val credentials: Int,
    val propertyId: String,
    val residentStatus: YardiResidentStatusEnum,
    val dateTo: String? = null,
    val dateFrom: String? = null,
)
